import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import estadoApp from './estadoApp.js'

Vue.config.productionTip = false

Vue.prototype.$estadoApp = estadoApp

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
